import React from "react";
import { C, Pill, FAQ } from "./shared";

export default function FaqsSection() {
  return (
    <section className="border-y" style={{ background: C.paper, borderColor: C.rule }}>
      <div className="max-w-4xl mx-auto px-6 py-16 md:py-20">
        <div className="text-center">
          <Pill color={C.navy}>FAQs</Pill>
          <h2 className="font-display font-black text-3xl md:text-5xl mt-3 tracking-tight" style={{ color: C.navyDeep }}>
            Common questions, answered.
          </h2>
        </div>
        <div className="mt-10 space-y-3">
          <FAQ defaultOpen
            q="Is SkillConnect free for students?"
            a="Yes — creating your profile, uploading certificates, applying to internships and earning CoE badges are all completely free. We never charge students." />
          <FAQ
            q="How are my skills verified?"
            a="Every CoE Lab module ends with a proctored MCQ + project assessment. You need 70%+ to pass. Passing earns you a tamper-proof certificate with a unique credential ID that recruiters can verify on a public URL." />
          <FAQ
            q="What's an employability score?"
            a="A 0–100 score combining profile completeness, verified skills, project depth, CoE badges and assessment performance. Recruiters use it to rank applicants — and you can see exactly what to improve each week." />
          <FAQ
            q="Which companies hire on SkillConnect?"
            a="200+ companies including Infotech Solutions, BlueCloud Labs, NovaFin Analytics and more — across product, engineering, hardware, EV, cybersecurity, IoT, and data roles." />
          <FAQ
            q="I'm a final-year student. Can I still join?"
            a="Absolutely. Many of our most-hired profiles come from final-year students — sign up, complete a CoE lab, and apply to roles that match your skills." />
          <FAQ
            q="How long until I hear back from a recruiter?"
            a="Median first response is under 72 hours for verified profiles with at least one CoE badge. Higher employability scores get prioritised." />
        </div>
      </div>
    </section>
  );
}
